/**
 * 将秒数格式化为 mm:ss 字符串
 * 例: 147 → "02:27"
 */
export const formatTime = (s: number): string => {
  const m = Math.floor(s / 60)
  const sec = Math.floor(s % 60)
  return `${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`
}

/**
 * 基于 seed 的伪随机数生成器
 * 用于生成稳定形态的波形条
 */
export const seededRand = (seed: number): (() => number) => {
  let s = seed
  return () => {
    s = (s * 9301 + 49297) % 233280
    return s / 233280
  }
}
